var React = require('react');

function SubfooterRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 163.511V55.6842L238.963 189.441V135.6L473 1V110.863L238.963 245.464L473 381.519V489.2L238.963 353.144V407.052L1 546.484V434.939L238.963 297.366L1 163.511Z","stroke":"#FFCC00","strokeOpacity":"0.5"}));
}

SubfooterRight.defaultProps = {"width":"165","height":"548","viewBox":"0 0 165 548","fill":"none"};

module.exports = SubfooterRight;

SubfooterRight.default = SubfooterRight;
